import { downloadTrackAsMp3 } from '@/lib/audioMp3'
import type { HostTrack } from '@/types/host'
import { Download, Loader2 } from 'lucide-react'
import { useState } from 'react'
import toast from 'react-hot-toast'

function DownloadMp3Button({ track }: { track: HostTrack }) {
  const [busy, setBusy] = useState(false)

  const onClick = async () => {
    if (busy) return
    setBusy(true)
    try {
      await downloadTrackAsMp3(track)
    } catch (error) {
      console.error('Falha ao baixar música:', error)
      toast.error(error instanceof Error ? error.message : 'Não foi possível baixar a música.')
    } finally {
      setBusy(false)
    }
  }

  return (
    <button
      type="button"
      onClick={() => void onClick()}
      disabled={busy}
      className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-[#0b2ea8] text-white disabled:opacity-60"
      aria-label="Baixar em MP3"
      title="Baixar em MP3"
    >
      {busy ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />}
    </button>
  )
}

export default DownloadMp3Button
